<template>
  <v-data-table
    :value="selected"
    :headers="headers"
    :items="items"
    :items-per-page="15"
    :search="search"
    :custom-filter="$options.localeIncludes"
    :loading="loading"
    :loading-text="$t('general.loading')"
    show-select
    @input="$emit('update:selected', $event)"
  >
    <template v-slot:[`item.defaultDraw`]="{ item }">
      <v-icon v-if="item.defaultDraw" color="accent" large>
        mdi-check
      </v-icon>
    </template>
    <template v-slot:[`item.actions`]="{ item }">
      <v-btn
        icon
        :to="`/multiproject/draws/${item.id}`"
      >
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import Helpers from 'src/utils/helpers'

export default {
  name: 'DrawList',
  props: {
    value: {
      type: Array,
      default: () => ([]),
    },
    selected: {
      type: Array,
      default: () => ([]),
    },
    search: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    headers () {
      return [
        {
          text: this.$t('multiproject.fields.draw.name'),
          value: 'name',
        },
        {
          text: this.$t('multiproject.fields.draw.type'),
          value: 'type',
          filterable: false,
          align: 'center',
          width: '15%',
        },
        {
          text: this.$t('multiproject.fields.draw.defaultDraw'),
          value: 'defaultDraw',
          filterable: false,
          align: 'center',
          width: '15%',
        },
        {
          text: this.$t('general.actions'),
          value: 'actions',
          sortable: false,
          filterable: false,
          align: 'center',
          width: '15%',
        },
      ]
    },
    items () {
      return this.value.map(draw => ({
        id: draw.id,
        name: draw.name,
        type: this.$t(`multiproject.fields.draw.typeList.${draw.type}`),
        defaultDraw: !!draw.defaultDraw,
      }))
    },
  },
  localeIncludes: Helpers.localeIncludes,
}
</script>
